// 自动加载  目录下的 .js 结尾的文件
const mixinContext = require.context('src/lang/en', true, /\.js$/)
let mixinImport = {}
mixinContext.keys().forEach(mixin => {
  // 排除不处理
  if (mixin.startsWith('./index.js')) {
    return
  }
  const mixinModule = mixinContext(mixin)
  mixinImport = Object.assign(mixinImport, mixinModule.default || mixinModule)
})
export default {
   ...mixinImport
}



// WEBPACK FOOTER //
// ./src/lang/en/index.js